import type { Location } from 'history';
import { LOCATION_CHANGE, replace } from 'redux-first-history';
import { takeEvery } from 'redux-saga/effects';

import { selectAuth } from '@/modules/auth/services/slices/auth';
import { getStore } from '@/services/context';
import type { LocationChangeAction } from '@/types';

const getPath = (location: Location) => `${location.pathname}?${location.search}${location.hash}`;

async function locationHandler(action: LocationChangeAction) {
    const { dispatch, getState } = await getStore();
    const {
        payload: { location },
    } = action;
    const search = new URLSearchParams(location.search);

    const { status: authStatus } = selectAuth(getState());

    if (!search.has('demoUser') && authStatus === 'authenticated') {
        search.set('demoUser', 'true');

        const path = getPath({
            ...location,
            search: search.toString(),
        });

        dispatch(replace(path));
    }
    if (search.has('demoUser') && authStatus === 'unauthenticated') {
        search.delete('demoUser');

        const path = getPath({
            ...location,
            search: search.toString(),
        });

        dispatch(replace(path));
    }
}

export function* trackLoggedDemoUserSaga() {
    yield takeEvery(LOCATION_CHANGE, locationHandler);
}
